import { marketingPressLogoSrc } from '@/config/marketing-assets.config'
import type { PressLogo } from '@/config/marketing-press.config'
import { cn } from '@/lib/utils'

export function AsSeenOn({
  title,
  logos,
  className,
}: {
  title: string
  logos: PressLogo[]
  className?: string
}) {
  if (logos.length === 0) return null

  return (
    <section className={cn('as-seen-on w-full', className)}>
      <div className="marketing-container">
        <h2 className="as-seen-on__title">{title}</h2>
        <ul className="as-seen-on__row">
          {logos.map((logo) => (
            <li key={logo.slug} className="as-seen-on__item">
              <img
                src={marketingPressLogoSrc(logo.slug)}
                alt={logo.name}
                width={logo.width}
                height={logo.height}
                loading="lazy"
                decoding="async"
                className="as-seen-on__logo"
              />
            </li>
          ))}
        </ul>
      </div>
    </section>
  )
}
